import { Box, FormControl, TextField } from '@mui/material';
import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import { useEffect, useRef, useState } from 'react';

const ValueBetweenFilter = ({ item, applyValue }: GridFilterInputValueProps): JSX.Element => {
  const initialized = useRef(false);
  const [min, setMin] = useState('');
  const [max, setMax] = useState('');
  useEffect(() => {
    let isMounted = true;

    if (!initialized.current && item.value) {
      const [initMin = '', initMax = ''] = item.value.split(',');
      if (isMounted) {
        setMin(initMin);
        setMax(initMax);
        initialized.current = true;
      }
    }
    return () => {
      isMounted = false;
    };
  }, [item.value]);

  const handleMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMin = e.target.value;
    setMin(newMin);
    applyValue({ ...item, value: `${newMin},${max}` });
  };

  const handleMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newMax = e.target.value;
    setMax(newMax);
    applyValue({ ...item, value: `${min},${newMax}` });
  };

  return (
    <Box display="flex">
      <FormControl fullWidth>
        <TextField
          variant="standard"
          InputLabelProps={{ shrink: true }}
          id="from-value"
          type="number"
          label="From"
          inputMode="decimal"
          value={min}
          onChange={handleMinChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          variant="standard"
          InputLabelProps={{ shrink: true }}
          id="to-value"
          inputMode="decimal"
          type="number"
          label="To"
          value={max}
          onChange={handleMaxChange}
        />
      </FormControl>
    </Box>
  );
};

export default ValueBetweenFilter;
